import { render, staticRenderFns } from "./PartiesDetail.vue?vue&type=template&id=fcd23938&scoped=true&"
import script from "./PartiesDetail.vue?vue&type=script&lang=js&"
export * from "./PartiesDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartiesDetail.vue?vue&type=style&index=0&id=fcd23938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd23938",
  null
  
)

export default component.exports